import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import FAQ from '@/views/FAQ'
import Register from '@/views/Register'
import Dashboard from '@/views/admin/Dashboard'
import Members from '@/views/admin/Members'
import Riders from '@/views/admin/Riders'
import TrackDuty from '@/views/admin/TrackDuty'
import MemberItem from '@/views/admin/MemberItem'
import AdminNews from '@/views/admin/News'
import Emails from '@/views/admin/Emails'
import Signin from '@/views/Signin'
import Account from '@/views/Account'
import { AmplifyEventBus, AmplifyPlugin } from 'aws-amplify-vue'
import * as AmplifyModules from 'aws-amplify'

import AmplifyStore from '@/store'

Vue.use(Router)
Vue.use(AmplifyPlugin, AmplifyModules)

let user
getUser()

AmplifyEventBus.$on('authState', async state => {
  if (state === 'signedOut') {
    user = null
    AmplifyStore.commit('setUser', null)
    router.push({ path: '/' })
  } else if (state === 'signedIn') {
    user = await getUser()
    router.push({ path: '/account' })
  }
})

async function getUser () {
  try {
    let user = await Vue.prototype.$Amplify.Auth.currentAuthenticatedUser()
    if (user && user.signInUserSession) {
      AmplifyStore.commit('setUser', user)
      return user
    }
  } catch (e) {
    AmplifyStore.commit('setUser', null)
    return null
  }
}

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: { requiresAuth: false }
    },
    {
      path: '/faq',
      name: 'Faq',
      component: FAQ,
      meta: { requiresAuth: false }
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      meta: { requiresAuth: true }
    },
    {
      path: '/account',
      name: 'Account',
      component: Account,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin',
      name: 'Dashboard',
      component: Dashboard,
      meta: { requiresAuth: true, requiresAdmin: true },
      children: [
        {
          path: 'news',
          meta: { requiresAuth: true, requiresAdmin: true },
          component: AdminNews
        },
        {
          path: 'emails',
          meta: { requiresAuth: true, requiresAdmin: true },
          component: Emails
        }
      ]
    },
    {
      path: '/admin/members',
      name: 'Members',
      component: Members,
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/admin/riders',
      name: 'Riders',
      component: Riders,
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/admin/duty',
      name: 'Duty',
      component: TrackDuty,
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/admin/members/:username',
      name: 'MemberItem',
      component: MemberItem,
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/auth',
      name: 'Authenticator',
      component: Signin
    }
  ]
})

router.beforeResolve(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    user = await getUser()
    if (!user) {
      return next({
        path: '/auth',
        query: {
          redirect: to.fullPath
        }
      })
    }

    // Only Users with no active subscription can apply for membership (unless reapplying)
    if (to.path === '/register') {
      try {
        let sub = JSON.parse(user.attributes['custom:subscription'])
        if (new Date().getTime() <= new Date(sub.subscriptionExp).getTime()) {
          /* TODO: REMOVE THIS AFTER TESTING */
          // return next({
          //   path: '/account'
          // })
        }

        return next()
      } catch (e) {
        return next()
      }
    }

    if (to.matched.some(record => record.meta.requiresAdmin)) {
      if (
        user &&
        user.attributes &&
        user.attributes['custom:capabilities'] &&
        user.attributes['custom:capabilities'].indexOf('administrator') >= 0
      ) {
        return next()
      }

      return next({
        path: '/account'
      })
    }

    return next()
  }
  return next()
})

export default router
